export const assign_reviewers = {
  Edit_steps: "Editar etapas",
  New_group_name: "Nome do novo grupo",
  Previously_created_groups: "Grupos criados anteriormente",
  Save_this_group: "Salvar este grupo",
  Selected_Theme: "Tema Selecionado",
  Steps: "Etapas",
} as const;
